// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2xbJx","savePackageButton":"ClientWallet_savePackageButton__3Ufu7"};